// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#filterTrigger>.a-btnCta span[data-v-c9ba9990]{display:none}#filterTrigger>.a-btnCta .a-btnIcon[data-v-c9ba9990]{margin:0}@media (min-width:640px){#filterTrigger .a-btnCta span[data-v-c9ba9990]{display:inherit}#filterTrigger>.a-btnCta .a-btnIcon[data-v-c9ba9990]{margin-right:15px}}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
